import { createContext, ReactNode, useContext, useMemo } from "react";

import { loadProvider, ProviderFields } from "@smart/bridge-providers-dom";

export type SignatureLogoVariant = "signit" | "trisign";

const ProviderInfoContext = createContext<ProviderFields | undefined>(
  undefined,
);

export const ProviderInfoProvider = ({
  children,
  source,
}: {
  children: ReactNode;
  source?: string;
}) => {
  const provider = useMemo(() => loadProvider(source), [source]);

  return (
    <ProviderInfoContext.Provider value={provider}>
      {children}
    </ProviderInfoContext.Provider>
  );
};

export const useIntakeProvider = () => useContext(ProviderInfoContext);

const toSignatureLogoVariant = (
  provider: ProviderFields | undefined,
): SignatureLogoVariant =>
  provider?.label === "triConvey" ? "trisign" : "signit";

export const signatureLogoVariantFromSource = (source?: string) =>
  toSignatureLogoVariant(loadProvider(source));

export const useSignatureLogoVariant = () =>
  toSignatureLogoVariant(useIntakeProvider());
